/* Store page genre cards (snippets/genre-browse.liquid).
 * While the cards are visible, CSS (genre-browse.css, :has) hides the song
 * table and the sidebar. Any intent to search the list — typing in the
 * search box, opening Filters, "Browse all" — hides the cards and the table
 * takes over; "Back to genres" restores them. The curated filter engine
 * (catalog-filters.js) keeps running underneath either way.
 */
(function () {
  function init() {
    var root = document.querySelector('.catalog[data-collection]');
    var panel = root ? root.querySelector('[data-genre-browse]') : null;
    if (!panel) return;
    var back = root.querySelector('[data-browse-back]');
    var search = root.querySelector('.catalog-search__input');
    var layout = root.querySelector('.catalog__layout');
    var toolbar = root.querySelector('.catalog__toolbar');

    function scrollToEl(el) {
      if (!el) return;
      var top = el.getBoundingClientRect().top + window.pageYOffset - 110;
      window.scrollTo({ top: top < 0 ? 0 : top, behavior: 'smooth' });
    }

    function browsing() {
      return !panel.hidden;
    }

    function toList() {
      if (!browsing()) return;
      panel.hidden = true;
      if (back) back.hidden = false;
    }

    function toBrowse() {
      if (search && search.value) {
        search.value = '';
        search.dispatchEvent(new Event('input', { bubbles: true }));
      }
      panel.hidden = false;
      if (back) back.hidden = true;
      scrollToEl(root);
    }

    if (search) {
      search.addEventListener('input', function () {
        if (search.value.trim()) toList();
      });
    }

    // Capture phase: runs before catalog-filters.js's own toggle handler.
    root.addEventListener('click', function (e) {
      var t = e.target && e.target.closest
        ? e.target.closest('[data-browse-all], [data-browse-back], [data-filters-toggle], .catalog-filters__summary')
        : null;
      if (!t) return;
      if (t.hasAttribute('data-browse-back')) {
        e.preventDefault();
        toBrowse();
        return;
      }
      if (!browsing()) return;
      if (t.hasAttribute('data-browse-all')) {
        e.preventDefault();
        toList();
        scrollToEl(toolbar);
        return;
      }
      if (t.hasAttribute('data-filters-toggle') && layout) {
        // Cards hid the sidebar; mark it hidden so the engine's toggle opens it.
        layout.setAttribute('data-filters-hidden', 'true');
      }
      toList();
    }, true);

    // "All genres": unfold the chip rows; only offered when they overflow.
    var chipList = panel.querySelector('[data-chips]');
    var more = panel.querySelector('[data-chips-more]');
    if (chipList && more) {
      var moreLabel = more.textContent;
      if (chipList.scrollHeight > chipList.clientHeight + 4) more.hidden = false;
      more.addEventListener('click', function () {
        var open = chipList.classList.toggle('is-expanded');
        more.setAttribute('aria-expanded', open ? 'true' : 'false');
        more.textContent = open ? more.getAttribute('data-less-label') : moreLabel;
      });
    }

    // Card artwork below the first row loads as its card nears the screen.
    var lazyHeads = panel.querySelectorAll('[data-gb-img]');
    function showArt(head) {
      head.style.setProperty('--gb-img', 'url("' + head.getAttribute('data-gb-img') + '")');
      head.style.setProperty('--gb-fallback', 'url("' + head.getAttribute('data-gb-fallback') + '")');
      head.removeAttribute('data-gb-img');
    }
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          io.unobserve(en.target);
          showArt(en.target);
        });
      }, { rootMargin: '600px 0px' });
      Array.prototype.forEach.call(lazyHeads, function (h) { io.observe(h); });
    } else {
      Array.prototype.forEach.call(lazyHeads, showArt);
    }

    // Chip links: smooth-scroll to the card, clear of the sticky header.
    panel.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.genre-browse__chip') : null;
      if (!a) return;
      var card = document.getElementById((a.getAttribute('href') || '').slice(1));
      if (!card) return;
      e.preventDefault();
      scrollToEl(card);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
